import { cn } from '@/lib/utils';

import { Colors, FontSizes } from '@/styles/types';

export type TextProps = {
  children: React.ReactNode;
  color?: Colors;
  variant?: FontSizes;
  classNames?: {
    wrapper?: string;
  };
} & React.HTMLAttributes<HTMLSpanElement>;

export function Text({
  children,
  classNames,
  color = 'neutral-N99',
  variant = 'body-l',
  ...rest
}: TextProps) {
  return (
    <p
      className={cn(
        `text-${color} text-${variant} break-words`,
        classNames?.wrapper
      )}
      data-tracker-component='text'
      {...rest}
    >
      {children}
    </p>
  );
}
